import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes, bonuses } from '../data/content';
import { PRICE, REGULAR_PRICE, SAVINGS, DISCOUNT_LABEL } from '../config/site';
import { CTAButton } from './CTAButton';
import { DailyCountdown } from './DailyCountdown';
export function OfferStack() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-white/75 px-5 py-14 sm:py-20" data-id="element-244" data-mp="2kwv3yz03bdnw">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[620px]" data-id="element-245" data-mp="1x70riijonr46">
        <h2 className="text-center font-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-246" data-mp="224j20ddcmeea">
          Dzisiaj otrzymujesz cały system
        </h2>

        <div className="mt-8 rounded-2xl border border-chem/20 bg-white p-5 shadow-sm shadow-chem/5 sm:p-7" data-id="element-247" data-mp="1edn737dlj32t">
          <ul className="space-y-2.5" data-id="element-248" data-mp="14p3b9sc09fie">
            {volumes.map(volume => <li key={volume.number} className="flex items-start gap-3" data-id="element-249" data-mp="14otki2j4z4bn">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-250" data-mp="19n4wojwwlqx1">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-251" data-mp="1efoghym6piaa" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-252" data-mp="1jd6gv0m4yp6o">
                  <span className="font-semibold text-ink" data-id="element-253" data-mp="lr947jufte2n">Tom {volume.number}</span> — {volume.title}
                </span>
              </li>)}
            {bonuses.map(bonus => <li key={bonus.badge} className="flex items-start gap-3" data-id="element-254" data-mp="von9cnawugfn">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-255" data-mp="vqhua1m6m8jq">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-256" data-mp="2743kzr7owi7d" />
                </span>
                <span className="text-sm leading-relaxed text-ink/85" data-id="element-257" data-mp="2b4vxqufrt58e">
                  <span className="font-semibold text-ink" data-id="element-258" data-mp="2b7091xg016ip">{bonus.badge}</span> — {bonus.title}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 grid grid-cols-2 gap-3 border-t border-dashed border-chem/25 pt-5 text-center" data-id="element-259" data-mp="709fobqm8spi">
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-260" data-mp="kzsol6r9482v">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-261" data-mp="g28z1ap3s8vm">10</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-262" data-mp="3ohsorzqkf95x">
                Elementów edukacyjnych
              </p>
            </div>
            <div className="rounded-xl bg-paper px-3 py-3" data-id="element-263" data-mp="3ke4eh9ajtzgz">
              <p className="font-display text-xl font-bold text-chem sm:text-2xl" data-id="element-264" data-mp="239jqtnhd6c4">568</p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink/65" data-id="element-265" data-mp="3tgne7kj1fvz0">
                Stron gotowych do wydruku
              </p>
            </div>
          </div>

          <div className="mt-5 flex flex-col items-center rounded-xl bg-chem-soft px-4 py-6 text-center" data-id="element-266" data-mp="30srmku8bsu93">
            <span className="rounded-full bg-chem px-3 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-267" data-mp="1g9xhzaxz1xom">
              {DISCOUNT_LABEL}
            </span>
            <span className="mt-3 text-sm text-ink/60" data-id="element-268" data-mp="179hfo4syswlc">
              Cena regularna: <span className="line-through" data-id="element-269" data-mp="177ejf317y786">{REGULAR_PRICE}</span>
            </span>
            <span className="mt-1 text-sm font-semibold text-chem-deep" data-id="element-270" data-mp="1c93z4vzdz92l">
              Cena premierowa: Twój dzisiejszy dostęp
            </span>
            <span className="mt-1 font-display text-5xl font-bold text-chem sm:text-6xl" data-id="element-271" data-mp="23zi2vzdor50j">
              {PRICE}
            </span>
            <span className="mt-2 text-sm font-semibold text-cta" data-id="element-272" data-mp="1pyxn7c32hpb9">Oszczędzasz {SAVINGS}</span>
            <p className="mt-3 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-273" data-mp="1uy0ruvf4xtip">
              Jednorazowa płatność • Bez abonamentu • Dostęp cyfrowy od razu
            </p>
          </div>
        </div>

        <div className="mt-6" data-id="element-274" data-mp="jkya3x1auxwy">
          <CTAButton label="Uzyskaj natychmiastowy dostęp" href="https://wizualna-chemia.impultienda.ar/checkout" data-id="element-275" data-mp="jl83luljzn7e" />
          <DailyCountdown data-id="element-276" data-mp="yvehsy18eu7f" />
        </div>
      </motion.div>
    </section>;
}